module.exports = __webpack_public_path__ + "img/iq.a4842758.png";